import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button, F0Icon } from '@factorialco/f0-react'
import { Download, Organization } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import useCreateJobCatalogTree from 'modules/job_catalog/hooks/useCreateJobCatalogTree'

export const EmptyJobCatalogTree = () => {
  const { company } = useCurrentSession()

  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const navigateToImportJobCatalog = () => {
    navigate(navigation.employees.jobCatalog.importJobCatalogTree.fullPath())
  }

  const legalEntities = useMemo(
    () => company.legalEntities.map((legalEntity) => legalEntity.id),
    [company]
  )

  const { loading, createJobCatalogTree } = useCreateJobCatalogTree()

  const createJobCatalog = async () => {
    const result = await createJobCatalogTree(company.id, legalEntities)

    const handled = handleResult(result, (errors) => {
      app.setFlash({
        type: 'wrong',
        message: errors.errors || i18n.t('errors.generic_error'),
      })
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('job_catalog.nodes.empty_state.tree.success'),
        time: 5000,
      })
    }
  }

  return (
    <Box
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={'s16'}
      height="full"
    >
      <Box className="rounded-xl border-1 border-f1-border">
        <F0Icon icon={Organization} size="lg" />
      </Box>
      <Box alignItems={'center'}>
        <Text.Header2>{i18n.t('job_catalog.nodes.empty_state.tree.title')}</Text.Header2>
        <Text.Normal color="grey800">
          {i18n.t('job_catalog.nodes.empty_state.tree.description')}
        </Text.Normal>
      </Box>
      <Box gap={'s16'} flexDirection="row" alignItems="center">
        <F0Button
          label={i18n.t('job_catalog.nodes.empty_state.tree.import')}
          icon={Download}
          disabled={loading}
          onClick={navigateToImportJobCatalog}
        />
        <F0Button
          label={i18n.t('job_catalog.nodes.empty_state.tree.create')}
          disabled={loading}
          variant="outline"
          onClick={createJobCatalog}
        />
      </Box>
    </Box>
  )
}
